export default "__VITE_ASSET__fb7f3a69__"